"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionActions = exports.collectionStore = void 0;
const tslib_1 = require("tslib");
var collection_1 = require("./collection");
Object.defineProperty(exports, "collectionStore", { enumerable: true, get: function () { return collection_1.collectionStore; } });
exports.collectionActions = tslib_1.__importStar(require("./actions"));
//# sourceMappingURL=index.js.map